import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from 'src/app/services/api/api.service';
import { UserInfoService } from 'src/app/services/user-info.service';
import {
  AnalyticsInfoDto,
  DateState,
  PaymentAnalyticsDto,
  PaymentPageDataDto,
  RefundsAnalyticsDto,
  RequestsDataDto,
} from '../models/analytics.model';

@Injectable({
  providedIn: 'root',
})
export class AnalyticsService {
  agentId: string | undefined;
  userId: number | undefined;

  constructor(
    private apiService: ApiService,
    private userInfoService: UserInfoService
  ) {
    this.userInfoService.userId$.subscribe({
      next: (res) => {
        this.userId = res;
      },
    });

    this.userInfoService.agentId$.subscribe({
      next: (res) => {
        this.agentId = res;
      },
    });
  }

  getPaymentsAnalytics(parameters: any): Observable<PaymentAnalyticsDto> {
    const url = `/agents/${this.agentId}/analytics/payments`;
    return this.apiService.httpGet<PaymentAnalyticsDto>(url, parameters);
  }

  getRefundsAnalytics(parameters: any): Observable<RefundsAnalyticsDto> {
    const url = `/agents/${this.agentId}/analytics/refunds`;
    return this.apiService.httpGet<RefundsAnalyticsDto>(url, parameters);
  }

  getSupportAnalytics() {
    const url = `/agents/${this.agentId}/analytics/support`;
    return this.apiService.httpGet<AnalyticsInfoDto>(url);
  }

  getRequestsAnalytics() {
    const url = `/agents/${this.agentId}/analytics/contacts_support`;
    return this.apiService.httpGet<RequestsDataDto[]>(url);
  }

  getPaymentPageAnalytics(year: number, month: number) {
    const url = `/agents/${this.agentId}/analytics/payment_page?month=${month}&year=${year}`;
    return this.apiService.httpGet<PaymentPageDataDto>(url);
  }
}
